// extracted by mini-css-extract-plugin
export default {"sessionsTableHeader":"SessionsTable_sessionsTableHeader__Q3gJp"};